module.exports = __webpack_public_path__ + "img/s1-2.22015a67.png";